var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NkUpsLine"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"line",attrs:{"id":_vm.lineId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }